(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-invitation-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const invitations = document.querySelectorAll('[data-email-invitation]');

    invitations.forEach((dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';

      const storageKey = 'tiles-for-four-email-invitation';
      const delayMilliseconds = Number(dialog.dataset.delay || 8) * 1000;
      const params = new URLSearchParams(window.location.search);
      const forceShow = params.get('email_invite') === 'show';
      const success = Boolean(dialog.querySelector('[data-email-invitation-success]'));
      const launcher = document.querySelector(`[data-email-invitation-launcher="${dialog.id}"]`);

      const readState = () => {
        try {
          return JSON.parse(window.localStorage.getItem(storageKey) || '{}');
        } catch {
          return {};
        }
      };

      const writeState = (state) => {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(state));
        } catch {
          return;
        }
      };

      const closeInvitation = () => {
        writeState(success ? { subscribed: true } : { dismissed: true });
        dialog.close();
        if (!success && launcher instanceof HTMLButtonElement) launcher.hidden = false;
      };

      if (launcher instanceof HTMLButtonElement) {
        launcher.addEventListener('click', () => {
          launcher.hidden = true;
          if (!dialog.open) dialog.showModal();
        });
      }

      dialog.querySelectorAll('[data-email-invitation-close]').forEach((button) => {
        button.addEventListener('click', closeInvitation);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeInvitation();
      });

      dialog.addEventListener('cancel', () => {
        writeState(success ? { subscribed: true } : { dismissed: true });
        if (!success && launcher instanceof HTMLButtonElement) launcher.hidden = false;
      });

      if (success) {
        writeState({ subscribed: true });
        dialog.showModal();
        return;
      }

      const state = readState();
      const footerSignup = document.querySelector('.email-signup-block');

      if (launcher instanceof HTMLButtonElement && footerSignup instanceof HTMLElement) {
        const footerObserver = new IntersectionObserver(
          ([entry]) => {
            const currentState = readState();
            if (dialog.open || currentState.subscribed) return;
            launcher.hidden = entry.isIntersecting ? true : !(currentState.dismissed || currentState.dismissedAt);
          },
          { threshold: 0.15 }
        );
        footerObserver.observe(footerSignup);
      }

      if (!forceShow && state.subscribed) return;
      if (!forceShow && (state.dismissed || state.dismissedAt)) {
        if (launcher instanceof HTMLButtonElement) launcher.hidden = false;
        return;
      }

      window.setTimeout(() => {
        if (!dialog.open) dialog.showModal();
      }, forceShow ? 0 : delayMilliseconds);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
